var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Twitter logo"),React.createElement("description",{"key":1},"Find SendGrid on Twitter"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M13.674 1.384a5.379 5.379 0 0 1-1.611.465A2.931 2.931 0 0 0 13.296.216a5.413 5.413 0 0 1-1.782.716A2.736 2.736 0 0 0 9.466 0C7.918 0 6.662 1.322 6.662 2.952c0 .231.024.456.072.672C4.403 3.501 2.336 2.327.952.54a3.07 3.07 0 0 0-.38 1.486c0 1.023.495 1.927 1.248 2.457A2.699 2.699 0 0 1 .55 4.113v.037c0 1.43.967 2.624 2.251 2.894-.236.07-.483.104-.74.104-.18 0-.357-.018-.527-.052.356 1.172 1.392 2.027 2.62 2.049A5.454 5.454 0 0 1 0 10.369a7.667 7.667 0 0 0 4.3 1.325c5.16 0 7.982-4.498 7.982-8.4 0-.128-.002-.256-.008-.38a5.87 5.87 0 0 0 1.4-1.53","fill":"#546B81"}))]);
}

Twitter.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12"};

module.exports = Twitter;

Twitter.default = Twitter;
